import React from 'react';
//styles;
import './index.scss';
//common components
import TableBody from './tBody';
import TableHead from './tHead';

const DesktopTable = props => {
  const {
    dataIndex,
    columns,
    loading,
    currentPage,
    pageSize,
    action,
    sort,
  } = props;
  return (
    <table className='tContainer panel panel-default' id='report'>
      <TableHead columns={columns} sort={sort} />
      <TableBody
        dataIndex={dataIndex}
        columns={columns}
        loading={loading}
        currentPage={currentPage}
        pageSize={pageSize}
        action={action}
      />
    </table>
  );
};

export default DesktopTable;
